module.exports = __webpack_public_path__ + "static/media/gallery-4-6.2b88cbd8.png";